import { atom } from 'jotai';

export const locationAtom = atom('/');
